(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const focusable = 'a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, theme.moneyFormat);
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  };
  const toast = (message) => { const el = $('.toast'); if (!el) return; el.textContent = message; el.hidden = false; clearTimeout(el.timer); el.timer = setTimeout(() => el.hidden = true, 3500); };
  const visibleFocusable = container => $$(focusable, container).filter(node => node.getClientRects().length > 0 && !node.closest('[inert]'));
  const trap = (container, event) => { const nodes = visibleFocusable(container); if (!nodes.length || event.key !== 'Tab') return; const first = nodes[0], last = nodes[nodes.length - 1]; if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); } else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); } };
  const setOverlayOpenerState = (el, expanded) => {
    if (!el?.id) return;
    $$('[data-open]').filter(button => button.dataset.open === el.id).forEach(button => button.setAttribute('aria-expanded', String(expanded)));
  };
  let lastFocus;
  function openOverlay(el) { if (!el) return; $$('.header__collections-menu[open]').forEach(details => details.removeAttribute('open')); lastFocus = document.activeElement; el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); setOverlayOpenerState(el, true); document.body.style.overflow = 'hidden'; requestAnimationFrame(() => ($('[data-initial-focus]', el) || visibleFocusable(el)[0])?.focus()); }
  function closeOverlay(el) { if (!el) return; el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); setOverlayOpenerState(el, false); if (!$$('.is-open').some(node => node.matches('.drawer,.modal,.mobile-menu,.catalog-filters'))) document.body.style.overflow = ''; lastFocus?.focus(); }
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open]');
    const closer = event.target.closest('[data-close]');
    const openCollections = $('.header__collections-menu[open]');
    if (opener) { event.preventDefault(); openOverlay(document.getElementById(opener.dataset.open)); $('.scrim')?.classList.add('is-open'); }
    if (closer) { event.preventDefault(); const target = closer.dataset.close ? document.getElementById(closer.dataset.close) : closer.closest('.drawer,.modal,.mobile-menu,.filters__form,.catalog-filters') || $('.drawer.is-open,.modal.is-open,.mobile-menu.is-open,.filters__form.is-open,.catalog-filters.is-open'); closeOverlay(target); $('.scrim')?.classList.remove('is-open'); }
    if (openCollections && !event.target.closest('.header__collections-menu')) openCollections.removeAttribute('open');
    if (!event.target.closest('.catalog-filter-menu') && !facetBreakpoint.matches) $$('.catalog-filter-menu[open]').forEach(menu => menu.removeAttribute('open'));
    if (!event.target.closest('.catalog-filter-dropdown')) $$('.catalog-filter-dropdown[open]').forEach(details => details.removeAttribute('open'));
  });
  document.addEventListener('click', (event) => {
    const unitButton = event.target.closest('[data-size-unit]');
    if (!unitButton) return;
    const guide = unitButton.closest('[data-size-guide]');
    if (!guide) return;
    const unit = unitButton.dataset.sizeUnit;
    $$('[data-size-unit]', guide).forEach(button => {
      const active = button === unitButton;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    $$('[data-inches][data-centimeters]', guide).forEach(cell => { cell.textContent = cell.dataset[unit]; });
    $$('[data-size-unit-label]', guide).forEach(label => { label.textContent = unit === 'centimeters' ? 'cm' : 'in'; });
  });
  document.addEventListener('keydown', (event) => {
    const open = $('.drawer.is-open,.modal.is-open,.mobile-menu.is-open,.catalog-filters.is-open');
    if (event.key === 'Escape' && open) { closeOverlay(open); $('.scrim')?.classList.remove('is-open'); }
    if (event.key === 'Escape') $('.header__collections-menu[open]')?.removeAttribute('open');
    if (event.key === 'Escape') $$('.catalog-filter-dropdown[open]').forEach(details => details.removeAttribute('open'));
    if (event.key === 'Escape' && !facetBreakpoint.matches) $$('.catalog-filter-menu[open]').forEach(menu => { menu.removeAttribute('open'); $('summary', menu)?.focus(); });
    if (open) trap(open, event);
  });
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.mobile-menu__collections-trigger');
    if (!trigger) return;
    const list = document.getElementById(trigger.getAttribute('aria-controls'));
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    if (list) list.hidden = expanded;
  });

  async function getCart() { const response = await fetch(theme.routes.cart, { headers: { Accept: 'application/json' } }); if (!response.ok) throw new Error('Cart unavailable'); return response.json(); }
  async function refreshCart(open = false) {
    try {
      const cart = await getCart();
      $$('.cart-count').forEach(el => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      const drawer = $('#CartDrawer');
      if (drawer) {
        const response = await fetch(`${location.pathname}?section_id=cart-drawer`);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const next = $('#CartDrawer', parsed);
        if (next) drawer.innerHTML = next.innerHTML;
        if (open && theme.cartDrawer) { openOverlay(drawer); $('.scrim')?.classList.add('is-open'); }
      }
    } catch (error) { toast(error.message); }
  }
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    const button = $('[type="submit"]', form); const original = button.textContent;
    button.disabled = true; button.textContent = button.dataset.adding || 'Adding…';
    try {
      const response = await fetch(theme.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message);
      button.textContent = button.dataset.added || 'Added to cart';
      await refreshCart(true);
    } catch (error) { toast(error.message); button.textContent = original; }
    finally {
      setTimeout(() => {
        const variantInput = form.querySelector('[name="id"]');
        const hasVariant = !variantInput || (!variantInput.disabled && variantInput.value);
        const canSubmit = hasVariant && button.dataset.available !== 'false';
        button.disabled = !canSubmit;
        const currentLabel = button.dataset.buttonPrice ? `${button.dataset.add} — ${formatMoney(Number(button.dataset.buttonPrice))}` : original;
        button.textContent = canSubmit ? currentLabel : (hasVariant ? button.dataset.soldOut : button.dataset.unavailable) || currentLabel;
      }, 1200);
    }
  });
  document.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    try {
      const response = await fetch(theme.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(input.dataset.line), quantity: Number(input.value) }) });
      if (!response.ok) throw new Error('Unable to update cart');
      if ($('#CartDrawer')?.classList.contains('is-open')) await refreshCart(false); else location.reload();
    } catch (error) { toast(error.message); }
  });
  document.addEventListener('click', async (event) => {
    const quantityButton = event.target.closest('[data-quantity-change]');
    if (quantityButton) { const input = quantityButton.parentElement.querySelector('input'); input.value = Math.max(Number(input.min || 0), Number(input.value) + Number(quantityButton.dataset.quantityChange)); input.dispatchEvent(new Event('change', { bubbles: true })); }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { event.preventDefault(); const input = document.querySelector(`[data-cart-quantity][data-line="${remove.dataset.line}"]`); if (input) { input.value = 0; input.dispatchEvent(new Event('change', { bubbles: true })); } }
  });

  $$('[data-product]').forEach(productRoot => {
    let data = {};
    try { data = JSON.parse($('[data-product-json]', productRoot)?.textContent || '{}'); } catch (_) { return; }
    const form = $('[data-product-form]', productRoot); if (!form || !data.variants) return;
    const optionInputs = $$('[data-option]', productRoot);
    const variantInput = $('[data-product-variant]', form) || $('[name="id"]', form);
    const add = $('[type="submit"]', form);
    const price = $('[data-product-price]', productRoot);
    const sticky = $('[data-sticky-atc]', productRoot);
    const stickyButton = sticky ? $('[type="submit"]', sticky) : null;
    const stickyPrice = sticky ? $('[data-sticky-price]', sticky) : null;
    const stickyOptions = sticky ? $('[data-sticky-options]', sticky) : null;
    const stickyImage = sticky ? $('.sticky-atc__image', sticky) : null;
    const inventory = $('[data-inventory-status]', productRoot);
    const infoPanel = $('.product__info--apparel', productRoot);
    const gallery = $('[data-media-gallery]', productRoot);
    const mediaStage = $('[data-media-stage]', productRoot);
    const stageGroups = $$('[data-gallery-group][data-gallery-view="stage"]', productRoot);
    const thumbnailGroups = $$('[data-gallery-group][data-gallery-view="thumbnail"]', productRoot);
    const thumbnailRail = $('[data-thumbnail-rail]', productRoot);
    const thumbnailColumn = $('[data-thumbnail-column]', productRoot);
    const thumbnailNext = $('[data-thumbnail-next]', productRoot);
    const previousMedia = $('[data-media-previous]', productRoot);
    const nextMedia = $('[data-media-next]', productRoot);
    const mediaCount = $('[data-media-count]', productRoot);
    const mediaCurrent = $('[data-media-current]', productRoot);
    const mediaTotal = $('[data-media-total]', productRoot);
    const galleryStatus = $('[data-gallery-status]', productRoot);
    const colorPosition = Number(productRoot.dataset.colorOptionPosition || 0) - 1;
    const sizePosition = Number(productRoot.dataset.sizeOptionPosition || 0) - 1;
    const galleryProductLabel = productRoot.dataset.galleryProductLabel || 'Product';
    const gallerySelectedLabel = productRoot.dataset.gallerySelectedLabel || 'selected.';
    const galleryUnavailableLabel = productRoot.dataset.galleryUnavailableLabel || 'Gallery unavailable.';
    const galleryUpdatedOne = productRoot.dataset.galleryUpdatedOne || 'Gallery updated with 1 image.';
    const galleryUpdatedMany = productRoot.dataset.galleryUpdatedMany || 'Gallery updated with __COUNT__ images.';
    const sizeFallbackTemplate = productRoot.dataset.sizeFallbackTemplate || 'Size __REQUESTED__ was unavailable; size changed to __REPLACEMENT__';
    let activeColor = '';
    let activeMediaItems = [];
    let activeMediaThumbs = [];
    let activeMediaIndex = 0;

    const formatTemplate = (template, replacements) => Object.entries(replacements).reduce(
      (message, [key, value]) => message.split(`__${key}__`).join(String(value)),
      template
    );

    const renderVariantPrice = (root, variant) => {
      if (!root || !variant) return;
      root.replaceChildren();
      if (variant.compare_at_price > variant.price) {
        const compare = document.createElement('span');
        compare.className = 'price__compare';
        const compareLabel = document.createElement('span');
        compareLabel.className = 'visually-hidden';
        compareLabel.textContent = root.dataset.compareLabel || 'Compare at price';
        compare.append(compareLabel, formatMoney(variant.compare_at_price));
        root.append(compare);
      }
      const current = document.createElement('span');
      const currentLabel = document.createElement('span');
      currentLabel.className = 'visually-hidden';
      currentLabel.textContent = root.dataset.priceLabel || 'Price';
      current.append(currentLabel, formatMoney(variant.price));
      root.append(current);
    };
    const syncInfoStickiness = () => {
      if (!infoPanel) return;
      const availableHeight = innerHeight - 144;
      const eligible = matchMedia('(min-width: 991px)').matches
        && infoPanel.scrollHeight <= availableHeight
        && gallery && gallery.offsetHeight > infoPanel.offsetHeight;
      infoPanel.classList.toggle('is-sticky-eligible', Boolean(eligible));
    };
    const syncStickyImage = () => {
      const source = $('img', activeMediaItems[0]);
      if (!stickyImage || !source) return;
      stickyImage.src = source.currentSrc || source.src;
      if (source.srcset) stickyImage.srcset = source.srcset; else stickyImage.removeAttribute('srcset');
      if (source.sizes) stickyImage.sizes = source.sizes;
    };
    const setGroupActive = (group, active) => {
      if (!group) return;
      group.hidden = !active;
      group.inert = !active;
      if (active) group.removeAttribute('aria-hidden'); else group.setAttribute('aria-hidden', 'true');
      $$('[data-media-thumbnail]', group).forEach(thumb => {
        thumb.disabled = !active;
        if (!active) thumb.tabIndex = -1;
      });
    };
    const syncGalleryControls = () => {
      const total = activeMediaItems.length;
      const hasMultiple = total > 1;
      [previousMedia, nextMedia].forEach(button => {
        if (!button) return;
        button.hidden = !hasMultiple;
        button.disabled = !hasMultiple;
      });
      if (mediaCount) mediaCount.hidden = !hasMultiple;
      if (mediaTotal) mediaTotal.textContent = String(total);
      if (thumbnailColumn) thumbnailColumn.hidden = !hasMultiple;
      if (thumbnailNext) thumbnailNext.hidden = total <= 6;
    };
    const showMedia = (mediaId, moveThumbnail = true) => {
      const nextIndex = activeMediaItems.findIndex(item => String(item.dataset.mediaId) === String(mediaId));
      if (nextIndex < 0) return;
      activeMediaIndex = nextIndex;
      activeMediaItems.forEach((item, index) => {
        const active = index === activeMediaIndex;
        item.hidden = !active;
        item.inert = !active;
        item.classList.toggle('is-active', active);
        if (active) item.removeAttribute('aria-hidden'); else item.setAttribute('aria-hidden', 'true');
      });
      activeMediaThumbs.forEach((thumb, index) => {
        const active = index === activeMediaIndex;
        thumb.disabled = false;
        thumb.tabIndex = active ? 0 : -1;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
      if (mediaCurrent) mediaCurrent.textContent = activeMediaItems[activeMediaIndex]?.dataset.mediaIndex || String(activeMediaIndex + 1);
      if (moveThumbnail) activeMediaThumbs[activeMediaIndex]?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    };
    const selectGalleryColor = (color, { reset = true, announce = false, sizeFallback = '' } = {}) => {
      const requestedColor = String(color || '');
      const previousMediaId = activeMediaItems[activeMediaIndex]?.dataset.mediaId;
      const stageGroup = colorPosition >= 0 ? stageGroups.find(group => group.dataset.galleryColor === requestedColor) : stageGroups[0];
      if (!stageGroup) {
        stageGroups.forEach(group => setGroupActive(group, false));
        thumbnailGroups.forEach(group => setGroupActive(group, false));
        activeColor = requestedColor;
        activeMediaItems = [];
        activeMediaThumbs = [];
        syncGalleryControls();
        if (galleryStatus) galleryStatus.textContent = `${requestedColor || galleryProductLabel} ${gallerySelectedLabel} ${galleryUnavailableLabel}`;
        return;
      }
      const resolvedColor = stageGroup?.dataset.galleryColor || '';
      const thumbnailGroup = colorPosition >= 0 ? thumbnailGroups.find(group => group.dataset.galleryColor === resolvedColor) : thumbnailGroups[0];
      stageGroups.forEach(group => setGroupActive(group, group === stageGroup));
      thumbnailGroups.forEach(group => setGroupActive(group, group === thumbnailGroup));
      activeColor = resolvedColor;
      activeMediaItems = stageGroup ? $$('[data-media-id]', stageGroup) : [];
      activeMediaThumbs = thumbnailGroup ? $$('[data-media-thumbnail]', thumbnailGroup) : [];
      const retainedMedia = !reset && activeMediaItems.find(item => item.dataset.mediaId === previousMediaId);
      showMedia((retainedMedia || activeMediaItems[0])?.dataset.mediaId, false);
      if (reset && thumbnailRail) thumbnailRail.scrollTo({ top: 0, left: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      syncGalleryControls();
      syncStickyImage();
      if (announce && galleryStatus) {
        const updatedMessage = activeMediaItems.length === 1
          ? galleryUpdatedOne
          : formatTemplate(galleryUpdatedMany, { COUNT: activeMediaItems.length });
        const fallbackMessage = sizeFallback ? ` ${sizeFallback}.` : '';
        galleryStatus.textContent = `${resolvedColor || galleryProductLabel} ${gallerySelectedLabel}${fallbackMessage} ${updatedMessage}`;
      }
    };
    const moveMedia = direction => {
      if (activeMediaItems.length < 2) return;
      const nextIndex = (activeMediaIndex + direction + activeMediaItems.length) % activeMediaItems.length;
      showMedia(activeMediaItems[nextIndex]?.dataset.mediaId);
    };

    productRoot.addEventListener('click', event => {
      const thumbnail = event.target.closest('[data-media-thumbnail]');
      if (thumbnail && !thumbnail.disabled) showMedia(thumbnail.dataset.mediaThumbnail);
    });
    thumbnailRail?.addEventListener('keydown', event => {
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key) || !event.target.matches('[data-media-thumbnail]')) return;
      event.preventDefault();
      let nextIndex = activeMediaIndex;
      if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = activeMediaItems.length - 1;
      else nextIndex = (activeMediaIndex + (event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1) + activeMediaItems.length) % activeMediaItems.length;
      showMedia(activeMediaItems[nextIndex]?.dataset.mediaId, false);
      activeMediaThumbs[nextIndex]?.focus();
    });
    previousMedia?.addEventListener('click', () => moveMedia(-1));
    nextMedia?.addEventListener('click', () => moveMedia(1));
    if (mediaStage) {
      let touchStartX = null;
      mediaStage.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
      mediaStage.addEventListener('touchend', event => {
        if (touchStartX === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 44) return;
        moveMedia(distance < 0 ? 1 : -1);
      }, { passive: true });
    }

    const checkedValues = () => $$('[data-option]:checked', productRoot)
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map(input => input.value);
    const findVariant = values => data.variants.find(variant => variant.options.every((option, index) => option === values[index]));
    const currentVariant = () => data.variants.find(variant => String(variant.id) === String(variantInput?.value));
    const syncInputsToVariant = variant => {
      if (!variant) return;
      optionInputs.forEach(input => {
        const position = Number(input.dataset.optionPosition) - 1;
        input.checked = variant.options[position] === input.value;
      });
    };
    const updateOptionAvailability = selectedValues => {
      optionInputs.forEach(input => {
        const linkedProductUrl = input.dataset.productUrl ? new URL(input.dataset.productUrl, location.origin) : null;
        const isLinkedProduct = linkedProductUrl && linkedProductUrl.pathname !== location.pathname;
        const position = Number(input.dataset.optionPosition) - 1;
        const candidate = [...selectedValues];
        candidate[position] = input.value;
        let matchingVariants = [];
        if (!isLinkedProduct) {
          matchingVariants = input.dataset.optionKind === 'color'
            ? data.variants.filter(variant => variant.options[position] === input.value)
            : data.variants.filter(variant => variant.options.every((value, index) => value === candidate[index]));
        }
        const available = isLinkedProduct ? input.dataset.optionAvailable !== 'false' : matchingVariants.some(variant => variant.available);
        const state = available ? 'available' : isLinkedProduct || matchingVariants.length ? 'sold-out' : 'unavailable';
        const optionValue = input.closest('.option-value');
        const status = $('[data-option-status]', optionValue);
        if (optionValue) optionValue.dataset.optionState = state;
        if (status) status.textContent = state === 'sold-out' ? (add?.dataset.soldOut || 'Sold out') : state === 'unavailable' ? (add?.dataset.unavailable || 'Unavailable') : '';
        input.disabled = !available && !input.checked;
      });
    };
    const updateVariantUrl = (variant, mode) => {
      if (!variant || mode === 'none') return;
      const variantUrl = new URL(location.href);
      variantUrl.searchParams.set('variant', variant.id);
      const nextUrl = `${variantUrl.pathname}${variantUrl.search}${variantUrl.hash}`;
      const state = { ...(history.state || {}), variantId: String(variant.id) };
      if (mode === 'push' && new URL(location.href).searchParams.get('variant') !== String(variant.id)) history.pushState(state, '', nextUrl);
      else if (mode === 'replace') history.replaceState(state, '', nextUrl);
    };
    const renderUnavailable = values => {
      const previousVariantId = variantInput?.value;
      values.forEach((value, index) => {
        const label = $(`[data-selected-option="${index + 1}"]`, productRoot);
        if (label) label.textContent = value;
      });
      if (variantInput) { variantInput.value = ''; variantInput.disabled = true; }
      form.classList.add('is-variant-unavailable');
      if (add) { add.disabled = true; add.dataset.available = 'false'; add.textContent = add.dataset.unavailable; }
      $$('[data-sticky-variant]', productRoot).forEach(input => { input.value = ''; input.disabled = true; });
      if (stickyButton) { stickyButton.disabled = true; stickyButton.dataset.available = 'false'; stickyButton.textContent = stickyButton.dataset.unavailable; }
      if (price) price.textContent = add?.dataset.unavailable || 'Unavailable';
      if (stickyPrice) stickyPrice.textContent = add?.dataset.unavailable || 'Unavailable';
      if (stickyOptions) stickyOptions.textContent = values.join(' / ');
      if (inventory) inventory.textContent = inventory.dataset.outOfStock || 'Out of stock';
      selectGalleryColor(colorPosition >= 0 ? values[colorPosition] : '', { reset: colorPosition >= 0 && values[colorPosition] !== activeColor, announce: colorPosition >= 0 && values[colorPosition] !== activeColor });
      updateOptionAvailability(values);
      if (variantInput && previousVariantId) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    };
    const applyVariant = (variant, { historyMode = 'none', resetGallery = false, announceGallery = false, sizeFallback = '' } = {}) => {
      if (!variant) { renderUnavailable(checkedValues()); return; }
      form.classList.toggle('is-variant-unavailable', !variant.available);
      const previousVariantId = variantInput?.value;
      syncInputsToVariant(variant);
      variant.options.forEach((value, index) => {
        const label = $(`[data-selected-option="${index + 1}"]`, productRoot);
        if (label) label.textContent = value;
      });
      updateOptionAvailability(variant.options);
      if (variantInput) { variantInput.value = variant.id; variantInput.disabled = !variant.available; }
      renderVariantPrice(price, variant);
      if (add) {
        add.disabled = !variant.available;
        add.dataset.available = String(variant.available);
        add.dataset.buttonPrice = String(variant.price);
        add.textContent = variant.available ? `${add.dataset.add} — ${formatMoney(variant.price)}` : add.dataset.soldOut;
      }
      updateVariantUrl(variant, historyMode);
      selectGalleryColor(colorPosition >= 0 ? variant.options[colorPosition] : '', { reset: resetGallery, announce: announceGallery, sizeFallback });
      $$('[data-sticky-variant]', productRoot).forEach(input => { input.value = variant.id; input.disabled = !variant.available; });
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyOptions) stickyOptions.textContent = variant.options.join(' / ');
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.dataset.available = String(variant.available);
        stickyButton.textContent = variant.available ? stickyButton.dataset.add : stickyButton.dataset.soldOut;
      }
      if (inventory) inventory.textContent = variant.available ? inventory.dataset.inStock : inventory.dataset.outOfStock;
      if (variantInput && String(previousVariantId) !== String(variant.id)) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      requestAnimationFrame(syncInfoStickiness);
    };

    productRoot.addEventListener('change', event => {
      if (!event.target.matches('[data-option]')) return;
      if (event.target.dataset.productUrl) {
        const productUrl = new URL(event.target.dataset.productUrl, location.origin);
        if (productUrl.pathname !== location.pathname) {
          const optionValueIds = $$('[data-option]:checked', productRoot)
            .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
            .map(input => input.dataset.optionValueId)
            .filter(Boolean);
          if (optionValueIds.length) productUrl.searchParams.set('option_values', optionValueIds.join(','));
          location.assign(productUrl);
          return;
        }
      }
      const previous = currentVariant();
      const values = checkedValues();
      const requestedSize = sizePosition >= 0 ? values[sizePosition] : '';
      let variant = findVariant(values);
      if (!variant?.available && event.target.dataset.optionKind === 'color') {
        variant = data.variants.find(candidate => candidate.available
          && candidate.options[colorPosition] === event.target.value
          && candidate.options.every((option, index) => index === colorPosition || index === sizePosition || option === values[index]));
        if (!variant) variant = data.variants.find(candidate => candidate.available && candidate.options[colorPosition] === event.target.value);
        if (variant) syncInputsToVariant(variant);
      }
      if (!variant) { renderUnavailable(values); return; }
      const nextColor = colorPosition >= 0 ? variant.options[colorPosition] : '';
      const colorChanged = colorPosition >= 0 && nextColor !== (previous?.options[colorPosition] || activeColor);
      const sizeFallback = sizePosition >= 0 && variant.options[sizePosition] !== requestedSize
        ? formatTemplate(sizeFallbackTemplate, { REQUESTED: requestedSize, REPLACEMENT: variant.options[sizePosition] })
        : '';
      applyVariant(variant, { historyMode: 'push', resetGallery: colorChanged, announceGallery: colorChanged || Boolean(sizeFallback), sizeFallback });
    });

    const initialVariant = data.variants.find(variant => String(variant.id) === String(productRoot.dataset.initialVariantId)) || findVariant(checkedValues()) || data.variants.find(variant => variant.available) || data.variants[0];
    syncInputsToVariant(initialVariant);
    applyVariant(initialVariant, { historyMode: 'replace', resetGallery: true, announceGallery: false });
    addEventListener('popstate', () => {
      const requestedId = new URL(location.href).searchParams.get('variant');
      const nextVariant = data.variants.find(variant => String(variant.id) === String(requestedId)) || initialVariant;
      const previous = currentVariant();
      const colorChanged = colorPosition >= 0 && nextVariant.options[colorPosition] !== previous?.options[colorPosition];
      applyVariant(nextVariant, { historyMode: 'none', resetGallery: colorChanged, announceGallery: colorChanged });
    });
    syncInfoStickiness();
    addEventListener('resize', syncInfoStickiness, { passive: true });
    if ('ResizeObserver' in window && infoPanel) {
      const infoResizeObserver = new ResizeObserver(syncInfoStickiness);
      infoResizeObserver.observe(infoPanel);
      if (gallery) infoResizeObserver.observe(gallery);
    }
    if (form && sticky && 'IntersectionObserver' in window) {
      const primaryPurchaseButton = $('[type="submit"]', form);
      if (primaryPurchaseButton) new IntersectionObserver(entries => sticky.classList.toggle('is-visible', !entries[0].isIntersecting), { threshold: 0 }).observe(primaryPurchaseButton);
      const footer = $('.footer');
      if (footer) {
        const updateStickyFooter = () => { const rect = footer.getBoundingClientRect(); sticky.classList.toggle('is-past-product', rect.top < innerHeight && rect.bottom > 0); };
        addEventListener('scroll', updateStickyFooter, { passive: true });
        updateStickyFooter();
      }
    }
  });

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-lightbox-image]');
    if (!trigger) return;
    const modal = document.getElementById('ProductLightbox');
    if (!modal) return;
    const image = $('img', modal);
    if (!image) return;
    const sourceImage = $('img', trigger.closest('[data-media-id]'));
    image.removeAttribute('srcset'); image.removeAttribute('sizes');
    image.src = trigger.dataset.lightboxImage; image.alt = sourceImage?.alt || '';
    openOverlay(modal); $('.scrim')?.classList.add('is-open');
  });

  async function loadProductRecommendations(section) {
    const urls = [...new Set([section.dataset.url, section.dataset.fallbackUrl].filter(Boolean))];
    for (const url of urls) {
      try {
        const response = await fetch(url);
        if (!response.ok) continue;
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const next = parsed.querySelector('[data-product-recommendations]');
        if (!next || !next.querySelector('.product-card')) continue;
        next.hidden = false;
        next.setAttribute('data-loaded', '');
        section.replaceWith(next);
        return;
      } catch (_) {
        // Try the related-products fallback if curated recommendations cannot load.
      }
    }
    section.hidden = true;
    section.setAttribute('data-loaded', '');
  }

  $$('[data-product-recommendations]:not([data-loaded])').forEach(loadProductRecommendations);

  $$('[data-thumbnail-next]').forEach(button => button.addEventListener('click', () => {
    const rail = button.closest('.product-gallery__thumbnail-column')?.querySelector('[data-thumbnail-rail]');
    if (!rail) return;
    const horizontal = matchMedia('(max-width: 749px)').matches;
    rail.scrollBy({ left: horizontal ? rail.clientWidth * .72 : 0, top: horizontal ? 0 : rail.clientHeight * .72, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  }));

  const footerMobile = matchMedia('(max-width: 749px)');
  const syncFooterDetails = media => $$('.footer__details').forEach(details => { details.open = !media.matches; });
  syncFooterDetails(footerMobile);
  footerMobile.addEventListener?.('change', event => syncFooterDetails(event));

  let predictiveTimer;
  $$('[data-predictive-input]').forEach(input => input.addEventListener('input', () => {
    clearTimeout(predictiveTimer); const target = document.getElementById(input.getAttribute('aria-controls')); const query = input.value.trim();
    if (query.length < 2) { if (target) target.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); return; }
    predictiveTimer = setTimeout(async () => {
      try { const url = `${theme.routes.predictive}?q=${encodeURIComponent(query)}&section_id=predictive-search&resources[limit]=6&resources[type]=product,page,article`; const html = await (await fetch(url)).text(); const parsed = new DOMParser().parseFromString(html, 'text/html'); target.innerHTML = parsed.querySelector('#shopify-section-predictive-search')?.innerHTML || ''; input.setAttribute('aria-expanded', String(target.childElementCount > 0)); } catch (_) { input.setAttribute('aria-expanded', 'false'); }
    }, 220);
  }));

  $$('[data-price-range]').forEach(range => {
    const min = $('[data-price-min]', range); const max = $('[data-price-max]', range);
    const minLabel = $('[data-min-label]', range); const maxLabel = $('[data-max-label]', range);
    if (!min || !max) return;
    const sync = changed => {
      if (Number(min.value) > Number(max.value)) {
        if (changed === min) max.value = min.value; else min.value = max.value;
      }
      if (minLabel) minLabel.textContent = formatMoney(Number(min.value) * 100);
      if (maxLabel) maxLabel.textContent = formatMoney(Number(max.value) * 100);
    };
    min.addEventListener('input', () => sync(min)); max.addEventListener('input', () => sync(max));
  });

  const facetForm = $('[data-facet-form]');
  facetForm?.addEventListener('submit', () => {
    $$('input[type="number"]', facetForm).forEach(input => { input.disabled = input.value.trim() === ''; });
  });
  facetForm?.addEventListener('change', event => {
    if (event.target.matches('[data-sort-select]')) return;
    if (!facetForm.classList.contains('catalog-filters--toolbar') && matchMedia('(min-width: 991px)').matches) facetForm.requestSubmit();
  });

  const facetBreakpoint = matchMedia('(max-width: 990px)');
  const syncFacetOverlay = () => {
    const toolbarFacet = $('.catalog-filters--toolbar');
    if (!toolbarFacet) return;
    const compactMenu = toolbarFacet.closest('.catalog-filter-menu');
    if (compactMenu) compactMenu.open = facetBreakpoint.matches;
    if (facetBreakpoint.matches) {
      if (!toolbarFacet.classList.contains('is-open')) toolbarFacet.setAttribute('aria-hidden', 'true');
    } else {
      toolbarFacet.classList.remove('is-open');
      toolbarFacet.removeAttribute('aria-hidden');
      setOverlayOpenerState(toolbarFacet, false);
      if (!$('.drawer.is-open,.modal.is-open,.mobile-menu.is-open')) {
        $('.scrim')?.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  };
  syncFacetOverlay();
  facetBreakpoint.addEventListener?.('change', syncFacetOverlay);

  document.addEventListener('click', async event => {
    const loadMore = event.target.closest('[data-load-more]');
    if (!loadMore || !window.fetch) return;
    event.preventDefault(); loadMore.classList.add('is-loading'); loadMore.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(loadMore.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('More products are unavailable right now.');
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = $('[data-catalog-grid]', parsed); const currentGrid = $('[data-catalog-grid]');
      if (!nextGrid || !currentGrid) throw new Error('More products are unavailable right now.');
      const addedCards = [...nextGrid.children];
      addedCards.forEach(card => currentGrid.appendChild(card));
      toast(`${addedCards.length} more products loaded.`);
      const nextButton = $('[data-load-more]', parsed);
      if (nextButton) { loadMore.href = nextButton.href; loadMore.classList.remove('is-loading'); loadMore.removeAttribute('aria-busy'); }
      else { loadMore.removeAttribute('href'); loadMore.removeAttribute('data-load-more'); loadMore.setAttribute('aria-disabled', 'true'); loadMore.textContent = 'All products loaded'; loadMore.classList.remove('is-loading'); loadMore.removeAttribute('aria-busy'); }
    } catch (error) { loadMore.classList.remove('is-loading'); loadMore.removeAttribute('aria-busy'); toast(error.message); }
  });

  if ('IntersectionObserver' in window && document.body.classList.contains('motion-enabled') && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.animate([{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'none' }], { duration: 550, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' }); observer.unobserve(entry.target); } }), { threshold: .12 });
    $$('[data-reveal]').forEach(el => observer.observe(el));
  }
})();
